import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-likert',
    templateUrl: './likert.component.html',
    styleUrls: ['./likert.component.scss'],
    standalone: false
})
export class LikertComponent implements OnInit {

  scaleOptions: number[] = []
  selectedOption: number = null

  @Input() scale: number
  @Input() leftLabel: string
  @Input() rightLabel: string
  @Input() value : number

  @Output() valueChange = new EventEmitter<number>();

  constructor() {
  }

  ngOnInit() {
    this.scaleOptions = Array.from({length: this.scale}, (_, i) => i + 1);
    if( this.value ){
      this.selectedOption = this.value
    }
  }

  select(option: number) {
    this.selectedOption = option
    this.valueChange.emit(option)
  }
}
